export const RESEND_ACTIVATION_EMAIL = "/api/resendActivationEmail"
